import { Licenses } from "../Data/Licenses.ts"
import { parsePhoneNumber } from 'libphonenumber-js'
export const phoneNoRegex = '^(\+)?\d*$/'
export const phoneNoRegexWith48 = /^\+48\s\d{3}\s\d{3}\s\d{3}$/
export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const zipCodeRegex = /^[0-9]{2}-[0-9]{3}$/

export const validateEmail = (email) => {
    return emailRegex.test(email);
};

export const validatePhoneNo = (phone) => {
    return phoneNoRegex.test(phone);
};

export const validatePhoneNoWith48 = (phone) => {
    return phoneNoRegexWith48.test(phone);
};

// Wymagane długości numerów krajowych [min, max].
// Tam gdzie min === max liczba cyfr jest dokładnie określona (reforma numeracji).
// Dane zgodne ze standardem ITU-T E.164.
const NATIONAL_LENGTHS = {
    // Europa Środkowo-Wschodnia
    PL: [9,  9],  // Polska — 9 cyfr od reformy 2001
    CZ: [9,  9],  // Czechy — 9 cyfr od reformy 2002
    SK: [9,  9],  // Słowacja — 9 cyfr
    HU: [8,  9],  // Węgry — 8 (stacjonarne) lub 9 (komórkowe)
    RO: [9,  9],  // Rumunia — 9 cyfr
    BG: [8,  9],  // Bułgaria — 8–9 cyfr
    HR: [8,  9],  // Chorwacja — 8–9 cyfr
    UA: [9,  9],  // Ukraina — 9 cyfr
    // Bałtyk
    LT: [8,  8],  // Litwa — dokładnie 8 cyfr
    LV: [8,  8],  // Łotwa — dokładnie 8 cyfr
    EE: [7,  8],  // Estonia — 7–8 cyfr
    // Europa Zachodnia (stała długość)
    FR: [9,  9],  // Francja — 9 cyfr
    ES: [9,  9],  // Hiszpania — 9 cyfr
    PT: [9,  9],  // Portugalia — 9 cyfr
    NL: [9,  9],  // Holandia — 9 cyfr
    BE: [8,  9],  // Belgia — 8 (stacjonarne) lub 9 (komórkowe)
    // Europa Zachodnia (zmienna długość)
    DE: [3, 11],  // Niemcy — bardzo zmienna (strefy 3–5, mobile 10–11)
    GB: [7, 10],  // Wielka Brytania — 7–10 cyfr
    AT: [4, 13],  // Austria — bardzo zmienna
    IT: [6, 11],  // Włochy — 6–11 cyfr
    // Skandynawia
    NO: [8,  8],  // Norwegia — dokładnie 8 cyfr
    DK: [8,  8],  // Dania — dokładnie 8 cyfr
    SE: [7, 10],  // Szwecja — 7–10 cyfr
    FI: [5, 12],  // Finlandia — bardzo zmienna
    // Poza Europą
    US: [10, 10], // USA — dokładnie 10 cyfr (NANP)
    CA: [10, 10], // Kanada — dokładnie 10 cyfr (NANP)
    AU: [9,  9],  // Australia — 9 cyfr
};

// Walidacja dla numerów międzynarodowych (zwracanych przez react-phone-input-2 jako same cyfry z kodem kraju, np. "48505505050")
export const validateInternationalPhone = (phone) => {
    if (!phone) return false;
    const digits = phone.replace(/\D/g, '');
    if (!digits) return false;
    try {
        const parsed = parsePhoneNumber('+' + digits);
        if (!parsed?.isValid()) return false;
        const nationalLength = parsed.nationalNumber?.length ?? 0;
        const rule = NATIONAL_LENGTHS[parsed.country];
        if (rule) return nationalLength >= rule[0] && nationalLength <= rule[1];
        // Kraje spoza słownika — odrzucamy tylko krótkie kody serwisowe (< 6 cyfr)
        return nationalLength >= 6;
    } catch {
        return false;
    }
};

export const validateZipCode = (zipCode) => {
    return zipCodeRegex.test(zipCode);
};

export const getIndeksHeader = (license) => {
    switch (license) {
        case Licenses.TgInstalacje:
            return 'INDEKS TG'
        default:
            return 'INDEKS'
    }
}

export function reverseDate(date) {
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
}

/**
 * DK : Funkcja konwertuje tekstowa date z DateBoxa na format dla API
 * @param {*} date 
 * @returns 
 */
export const convertTextDateToDateObiect = (date) => {
    if (!date) {
        return null
    }
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}